import { message } from 'antd';
import Cookies from 'cookies-js';
import {
    ACCESS_TOKEN,
} from '../services/BaseRefreshHelper';

const CMS_DOMAIN = process.env.REACT_APP_DOMAIN

let controller = null;

async function fetchStream({ question, token }) {
    const encodeUri = encodeURIComponent(question);
    const url = `${CMS_DOMAIN}/llm/ask-question?question=${encodeUri}`;
    controller = new AbortController();

    const res = await fetch(url, {
        headers: {
            "Authorization": `JWT ${token}`,
            Accept: 'text/event-stream',
        },
        signal: controller.signal,
    });

    return res;
}

export default {
    namespace: 'llm',
    state: {
        answer: '',
        error: null,
        finished: false,
    },
    reducers: {
        updateState(state, { payload }) {
            return { ...state, ...payload };
        },
        append(state, { payload }) {
            return { ...state, answer: state.answer + payload };
        },
        reset(state, { payload }) {
            return { answer: "", error: null, finished: false };
        },
    },
    effects: {
        *startQuestion({ payload }, { call, put, select }) {
            const adminId = yield select(state => state.users.userId)
            yield put({ type: 'reset' });
            const question = payload.question;
            const currentAccessToken = Cookies.get(ACCESS_TOKEN);
            
            try {
                let res = yield call(fetchStream, { question, token: currentAccessToken });

                // If token expired
                if (res.status === 401 || res.status === 403) {
                    yield put({ type: "admin/getOneAdmin", payload: { id: adminId } });
                    const newAccessToken = Cookies.get(ACCESS_TOKEN);
                    res = yield call(fetchStream, { question, token: newAccessToken });
                }

                if (!res.ok) {
                    const text = yield call([res, 'text']);
                    yield put({ type: "updateState", payload: { error: text } })
                    throw new Error(text);
                }

                const reader = res.body.getReader();
                const decoder = new TextDecoder('utf-8');
                let buffer = '';

                while (true) {
                    const { done, value } = yield call([reader, 'read']);
                    if (done) break;

                    buffer += decoder.decode(value, { stream: true });
                    const parts = buffer.split('\n\n');
                    buffer = parts.pop();
                    for (const part of parts) {
                        if (!part.startsWith('data:')) continue;
                        const raw = part.slice(5).trim();
                        const data = JSON.parse(raw);
                        if (data.answer) {
                            yield put({ type: 'append', payload: data.answer });
                        }
                        if (data.event === 'workflow_finished') {
                            yield put({ type: 'updateState', payload: { finished: true, loading: false, error: null } });
                            return;
                        }
                        if (data.error || data.detail) {
                            throw new Error(data.error || data.detail);
                        }
                    }
                }
                yield put({ type: 'updateState', payload: { loading: false, finished: true, error: null } });
            } catch (err) {
                yield put({ type: "updateState", payload: { error: err.message } })
            }
        },

        *abort(_, { put }) {
            if (controller) {
                controller.abort();
                controller = null;
            }
            yield put({ type: 'reset' });
        },
    },
};
